import React, { useEffect, useState } from "react";
import { customLinkData, customPreHeader, customMenuUISettings, clientIds } from "../../../../config/clients/clients";
import DropDown from "../../../../component/dropdown/dropdown";
import PreHeader from "../PreHeader";
import { useDispatch, useSelector } from "react-redux";
import useClientConfig from "../../../../config/careers/clientConfig";

const DefaultCustomMenu = (props: any) => {

    const { menuSettings, clientId } = props;
    const [navOpen, setNavOpen] = useState<boolean>(false);
    const [scrolled, setScrolled] = useState(false);
    const {clientSiteSettings, clientMenuSettings} = useClientConfig();    
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    
    const [linkListData, setLinkListData] = useState<any>({
        id : "",
        linkList : []
    });

    

    useEffect(() => {
        
        const handleScroll = () => {
            if(clientSiteSettings?.showPreHeader === true){
                setScrolled(window.scrollY > 50);
            }
        };
    
        // Add the scroll event listener
        window.addEventListener("scroll", handleScroll);
    
        // Cleanup the event listener on component unmount
        return () => {
        window.removeEventListener("scroll", handleScroll);
        };
        
    }, []);

    useEffect(() => { 
        if (menuSettings) {
            setLinkListData(clientMenuSettings);
        }
    }, [customLinkData, menuSettings]);

    const toggleLinkListData = (currentId:any, toggle:boolean) => {
        setLinkListData((listItems:any) => {
            let modifiedList = listItems.linkList;
            let currentItemIndex = modifiedList.findIndex((item: { id: any; }) => item.id === currentId);            
            // modifiedList[currentItemIndex]["open"] = toggle;
            
            modifiedList = modifiedList.map((item: any, index: number) => 
                index === currentItemIndex ? { ...item, open: toggle } : item
            );
            
            return {
                ...listItems,
                linkList : modifiedList
            };
          });
    };

    //Mouse enter to toggle dropdown, acts as touch during mobile responsive
    const onMouseEnter = (currentId:any) => {
        toggleLinkListData(currentId, true);
    };

    const onMouseLeave = (currentId:any) => {
        toggleLinkListData(currentId, false);
    };

    const toggleNavBar = () => {
        navOpen ? setNavOpen(false) : setNavOpen(true);
        if(navOpen) {
            document.body.classList.remove("menu-open-body");
        } else {
            document.body.classList.add("menu-open-body");
        }
    };

    return (
        <> 
            <header>
                <div className="header">
                    <div className="container-new">
                        <PreHeader />
                        <div className={`head-parent ${scrolled ? "fixed-header" : ""}`}>
                            <div className="head-left">
                                <div className="logo-new">
                                    <a href={menuSettings.homeLinkHref} rel="noreferrer" target="_blank">
                                        <img src={process.env.PUBLIC_URL + menuSettings.logoimg} className="cust-logo-desktop-img"/>
                                        <img src={process.env.PUBLIC_URL + menuSettings.moblogoimg}  className="cust-logo-mob-img" />
                                    </a>
                                </div>
                            </div>
                            <button className={navOpen ? "responsive-nav-btn menu-open" : "responsive-nav-btn menu-closed"} onClick={toggleNavBar}><img className="menu-open-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggle}/><img className="menu-close-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggleClose}/></button>
                            
                            <div className="head-right">
                                
                                <nav className={navOpen ? "nav-open" : "nav-closed"}>
                                    <ul className="submenu-list">
                                        {clientSiteSettings?.showGetQuoteButton === true ? (
                                        <li className="mob-page-id-2-safe-quote">
                                            <a href="https://www.breathe-safe.com.au/get-a-quote/" target="_blank" rel="noopener noreferrer">GET A QUOTE</a>
                                        </li>
                                        ) : ""}
                                        {linkListData?.linkList.map((listItem:any) => {
                                            return (
                                                <li 
                                                    key={listItem.href}
                                                    onMouseEnter={() => onMouseEnter(listItem.id)}
                                                    onMouseLeave={() => onMouseLeave(listItem.id)}
                                                    className={listItem.open ? "open" : ""}
                                                >
                                                    <a href={listItem.href} title={listItem.name} rel="noreferrer" target="_blank"> {listItem.name} {listItem.open}</a>                                                        
                                                    <DropDown submenuItems={listItem.submenu} menuSettings={menuSettings} hideSubMenu={listItem?.hideSubMenu}/>
                                                    <span className="menu-arrow" onClick={() => onMouseEnter(listItem.id)}></span>
                                                </li>
                                            );
                                        })}

                                        
                                        
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>    
            </header>
        </>
    );
};


export default DefaultCustomMenu;